
export default {
  defaultContent: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '40px'
  } as React.CSSProperties
};
